export default function Footer() {
  return (
    <footer className="bg-[#2C3E50] text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div className="md:col-span-2">
            <div className="mb-6">
              <span className="font-['Andrea'] text-4xl font-bold text-white">stayx.</span>
            </div>
            <p className="font-['Satoshi'] text-sm text-gray-300 leading-relaxed mb-6">
              Convertimos tu vivienda en una fuente de ingresos pasivos. Gestión profesional de alquileres vacacionales en Airbnb y Booking.
            </p>
            <div className="flex gap-4">
              <a 
                href="#" 
                className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-full hover:bg-white/20 transition-all duration-300 cursor-pointer"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a 
                href="#" 
                className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-full hover:bg-white/20 transition-all duration-300 cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a 
                href="#" 
                className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-full hover:bg-white/20 transition-all duration-300 cursor-pointer"
                aria-label="LinkedIn"
              >
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a 
                href="https://wa.me/34633123150" 
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-full hover:bg-white/20 transition-all duration-300 cursor-pointer"
                aria-label="WhatsApp"
              >
                <i className="ri-whatsapp-line text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-['Andrea'] text-lg font-bold mb-4">Legal</h4>
            <ul className="space-y-3">
              <li>
                <a href="#" className="font-['Satoshi'] text-sm text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Política de Privacidad
                </a>
              </li>
              <li>
                <a href="#" className="font-['Satoshi'] text-sm text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Términos y Condiciones
                </a>
              </li>
              <li>
                <a href="#" className="font-['Satoshi'] text-sm text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Aviso Legal
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-['Andrea'] text-lg font-bold mb-4">Contacto</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <i className="ri-phone-line text-lg mt-0.5"></i>
                <a href="tel:+34633123150" className="font-['Satoshi'] text-sm text-gray-300 hover:text-white transition-colors cursor-pointer">
                  +34 633 123 150
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-lg mt-0.5"></i>
                <a href="mailto:info@stayx.com" className="font-['Satoshi'] text-sm text-gray-300 hover:text-white transition-colors cursor-pointer">
                  info@stayx.com
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-lg mt-0.5"></i>
                <span className="font-['Satoshi'] text-sm text-gray-300">
                  España
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="font-['Satoshi'] text-sm text-gray-400">
              © STAYX 2025. Todos los derechos reservados.
            </p>
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank"
              rel="noopener noreferrer"
              className="font-['Satoshi'] text-sm text-gray-400 hover:text-white transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
